import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers";
import {
  selectTipologiaDocumento,
  selectIsLoading,
} from "../../../features/documenti/documentiSlice";
import {
  createdocumenti,
  fetchDocumenti,
  fetchtipologiaDocumento,
  singleDocumenti,
  updateDocumentiData,
} from "../../../features/documenti/documentiThunk";
import {
  TextField,
  MenuItem,
  Button,
  Card,
  CardContent,
  Typography,
  IconButton,
  Box,
  Grid,
  TextareaAutosize,
  Autocomplete,
  Paper,
} from "@mui/material";
import styled from "@emotion/styled";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import ImageIcon from "@mui/icons-material/Image";
import "dayjs/locale/it";
import { useDispatch, useSelector } from "react-redux";
import { selectStatoIntervento } from "../../../features/manutenzione/manutenzioneSlice";
import { fetchStatoIntervento } from "../../../features/manutenzione/manutenzioneThunk";
dayjs.locale("it");
const schema = yup.object().shape({
  nomeDocumento: yup.string().required("Nome Documento è obbligatorio"),
  tipologiaIntervento: yup.string(),
  scadenza: yup
    .mixed()
    .required("Scadenza è obbligatoria")
    .test("is-valid", "Inserisci una data valida", (value) => {
      return dayjs.isDayjs(value) && value.isValid();
    }),
  statoIntervento: yup.string().required("Stato intervento è obbligatorio"),
  allegati: yup.mixed(),
});

const FilePreview = ({ file }) => {
  const [previewUrl, setPreviewUrl] = useState(null);
  const [fileType, setFileType] = useState(null);

  useEffect(() => {
    if (!file) return;

    // Handle URL strings (existing files from backend)
    if (typeof file === "string") {
      setPreviewUrl(file);
      // Try to guess the file type from URL
      if (file.match(/\.(jpeg|jpg|png|gif|bmp|webp)$/i)) {
        setFileType("image");
      } else if (file.match(/\.(pdf)$/i)) {
        setFileType("pdf");
      } else if (file.match(/\.(doc|docx)$/i)) {
        setFileType("doc");
      } else if (file.match(/\.(txt|text)$/i)) {
        setFileType("text");
      } else {
        setFileType("other");
      }
      return;
    }

    // Handle File objects
    if (file instanceof File) {
      if (file.type.startsWith("image/")) {
        setPreviewUrl(URL.createObjectURL(file));
        setFileType("image");
      } else if (file.type === "application/pdf") {
        setPreviewUrl(URL.createObjectURL(file));
        setFileType("pdf");
      } else if (
        file.type.includes("document") ||
        file.type.includes("msword")
      ) {
        setFileType("doc");
        setPreviewUrl(URL.createObjectURL(file));
      } else if (file.type === "text/plain") {
        setFileType("text");
        setPreviewUrl(URL.createObjectURL(file));
      } else {
        setFileType("other");
        setPreviewUrl(URL.createObjectURL(file));
      }
    }
  }, [file]);

  useEffect(() => {
    // Clean up object URLs to avoid memory leaks
    return () => {
      if (previewUrl && typeof file !== "string") {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl, file]);

  const openInNewTab = () => {
    if (previewUrl) {
      window.open(previewUrl, "_blank");
    }
  };

  if (!file) return null;

  return (
    <Paper elevation={1} sx={{ p: 2, mt: 1, mb: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
        {fileType === "image" && <ImageIcon color="primary" />}
        {fileType === "pdf" && <PictureAsPdfIcon color="error" />}
        {fileType === "doc" && <InsertDriveFileIcon color="primary" />}
        {fileType === "text" && <TextSnippetIcon color="info" />}
        {fileType === "other" && <InsertDriveFileIcon color="action" />}

        {/* <Typography variant="body2" sx={{ ml: 1 }}>
                    {file instanceof File ? file.name : file.split('/').pop()}
                </Typography> */}
      </Box>

      {fileType === "image" && previewUrl && (
        <Box
          sx={{
            mt: 1,
            textAlign: "center",
            cursor: "pointer",
            "&:hover": { opacity: 0.9 },
          }}
          onClick={openInNewTab}
        >
          <img
            src={previewUrl}
            alt="File Preview"
            style={{ maxWidth: "100%", maxHeight: "150px" }}
          />
        </Box>
      )}

      {fileType === "pdf" && previewUrl && (
        <Box
          sx={{
            mt: 1,
            height: "150px",
            width: "100%",
            overflow: "hidden",
            position: "relative",
            cursor: "pointer",
            "&:hover": { opacity: 0.95 },
          }}
          onClick={openInNewTab}
        >
          <iframe
            src={`${previewUrl}#toolbar=0&navpanes=0&scrollbar=0`}
            title="PDF Preview"
            width="100%"
            height="100%"
            scrolling="no"
            style={{
              border: "none",
              overflow: "hidden",
              width: "100%",
              height: "100%",
            }}
          />
          {/* Invisible overlay for clickable area */}
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: 1,
            }}
          />
        </Box>
      )}

      {(fileType === "doc" || fileType === "text" || fileType === "other") &&
        previewUrl && (
          <Box
            sx={{
              mt: 1,
              p: 2,
              bgcolor: "#f5f5f5",
              borderRadius: 1,
              cursor: "pointer",
              "&:hover": { bgcolor: "#e0e0e0" },
            }}
            onClick={openInNewTab}
          >
            {/* <Typography variant="body2" align="center">
                        Click to open file
                    </Typography> */}
          </Box>
        )}

      {(fileType === "doc" || fileType === "text" || fileType === "other") &&
        !previewUrl && (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mt: 1, fontStyle: "italic" }}
          >
            Preview not available for this file type
          </Typography>
        )}
    </Paper>
  );
};

const DocumentiForm = ({ cantine, setCantine, singleData, onClose }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsLoading);
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      nomeDocumento: "",
      tipologiaIntervento: null,
      scadenza: null,
      statoIntervento: null,
      allegati: null,
    },
  });
  const tipologiaDocumento = useSelector(selectTipologiaDocumento);
  const statoIntervento = useSelector(selectStatoIntervento);
  // console.log('data of tipo',tipologiaDocumento);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [allegatiPreview, setAllegatiPreview] = useState(null);

  useEffect(() => {
    dispatch(fetchtipologiaDocumento());
    dispatch(fetchStatoIntervento());
    if (cantine) {
      console.log(singleData);

      setValue("nomeDocumento", singleData?.doc_name || "");
      setValue("tipologiaIntervento", singleData?.tipo_di_invento);
      setValue(
        "scadenza",
        singleData?.scadenza ? dayjs(singleData.scadenza) : null
      );
      setValue("statoIntervento", singleData?.stato_intervento);
      setValue("allegati", singleData?.carica_file || null);
      if (singleData?.carica_file) {
        setAllegatiPreview(singleData.carica_file);
      }
    }
  }, [singleData, setValue]);

  const onSubmit = (data) => {
    const formData = new FormData();
    formData.append("company_id", localStorage.getItem("company_id"));
    formData.append("mezzi_id",  localStorage.getItem('mezzi_id'));
    formData.append("doc_name", data?.nomeDocumento);
    formData.append("tipo_di_invento", data?.tipologiaIntervento);
    formData.append(
      "scadenza",
      data?.scadenza ? dayjs(data.scadenza).format("YYYY-MM-DD") : null
    );
    formData.append("stato_intervento", data?.statoIntervento);
    // formData.append("carica_file", data?.allegati);
    if (data.allegati instanceof File) {
      formData.append("carica_file", data.allegati);
    }

    const updateData = new FormData();

    updateData.append("doc_name", data?.nomeDocumento);
    updateData.append("tipo_di_invento", data?.tipologiaIntervento);
    updateData.append(
      "scadenza",
      data?.scadenza ? dayjs(data.dataIntervento).format("YYYY-MM-DD") : ""
    );
    updateData.append("stato_intervento", data?.statoIntervento);

    // Attach the file as binary
    if (data?.allegati instanceof File) {
      updateData.append("carica_file", data.allegati);
    }

    if (cantine) {
      // debugger
      dispatch(updateDocumentiData({ id: singleData?.id, data: updateData }))
        .unwrap()
        .then(() => {
          dispatch(singleDocumenti(singleData.id));
          setCantine(false);
          localStorage.removeItem("documentiLogistica");
        })
        .catch((err) => console.error("Update Error:", err));
    } else {
      dispatch(createdocumenti(formData))
        .unwrap()
        .then(() => {
          setOpenSnackbar(true);
          setCantine(false);
        })
        .catch((err) => console.error("Create Error:", err));
    }
  };

  // const handleFileChange = (e, onChange) => {
  //     const file = e.target.files[0];
  //     if (file) {
  //         onChange(file);
  //     }
  // };
  const handleFileChange = (e, onChange) => {
    const file = e.target.files[0];
    if (file) {
      onChange(file);
      setAllegatiPreview(file);
    }
  };

  return (
    <>
      <form className="AziendaFrom" onSubmit={handleSubmit(onSubmit)}>
        <div className="AziendaFrom__inner">
          <Controller
            name="nomeDocumento"
            control={control}
            render={({ field }) => (
              <TextField
                className="customTextBox"
                {...field}
                label="Nome Documento"
                fullWidth
                margin="normal"
                error={!!errors.nomeDocumento}
                helperText={errors.nomeDocumento?.message}
              />
            )}
          />
          <Controller
            name="tipologiaIntervento"
            control={control}
            render={({ field }) => (
              <Autocomplete
                {...field}
                options={tipologiaDocumento || []}
                // getOptionLabel={(option) => option.name}
                value={field.value}
                onChange={(event, value) => field.onChange(value)} // To handle selected value properly
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Tipologia di intervento"
                    className="customTextBox autoCompleteTextBox"
                    margin="normal"
                    fullWidth
                    error={!!errors.tipologiaIntervento}
                    helperText={errors.tipologiaIntervento?.message}
                  />
                )}
              />
            )}
          />
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
            <Controller
              name="scadenza"
              control={control}
              render={({ field }) => (
                <DatePicker
                  className="datePickerField"
                  label="Scadenza"
                  value={field.value}
                  onChange={(newValue) => field.onChange(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={!!errors.scadenza}
                      helperText={errors.scadenza?.message}
                      fullWidth
                      margin="normal"
                    />
                  )}
                />
              )}
            />
          </LocalizationProvider>
          <Controller
            name="statoIntervento"
            control={control}
            render={({ field }) => (
              <Autocomplete
                {...field}
                options={statoIntervento || []}
                onChange={(event, value) => field.onChange(value)} // To handle selected value properly
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Stato Intervento"
                    className="customTextBox autoCompleteTextBox"
                    margin="normal"
                    fullWidth
                    error={!!errors.statoIntervento}
                    helperText={errors.statoIntervento?.message}
                  />
                )}
              />
            )}
          />
          <Controller
            name="allegati"
            control={control}
            render={({ field: { onChange, value, ...field } }) => (
              <>
                <Grid container spacing={1}>
                  <Grid item xs={8}>
                    <TextField
                      {...field}
                      value={
                        value instanceof File
                          ? value.name
                          : typeof value === "string"
                          ? value
                          : "No file uploaded"
                      }
                      className="customTextBox"
                      label="Allegati"
                      fullWidth
                      margin="normal"
                      InputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Button
                      className="caricafile-label"
                      variant="outlined"
                      component="label"
                    >
                      Carica file
                      <input
                        type="file"
                        hidden
                        onChange={(e) => handleFileChange(e, onChange)}
                      />
                    </Button>
                  </Grid>
                </Grid>
                {allegatiPreview && <FilePreview file={allegatiPreview} />}
              </>
            )}
          />

          <div className="btnPart1">
            <Button type="submit" variant="contained">
              Salva dati
            </Button>
          </div>
        </div>
      </form>
    </>
  );
};
export default DocumentiForm;
